import { Navigate } from 'react-router-dom';
import { useAuthentication } from "authentication/AuthenticationContext";
import loadingLogo from "images/BlogFreeRecipeLogo.png";
import React from 'react';

const AdminRoute = ({ children }) => {
  const { isAdmin, loading, user } = useAuthentication();

  if (loading) {
    return (
      <div className="p1 Justify-Center">
         <img
          className="loading"
          src={loadingLogo}
          alt="spinning logo"
          id="Logo"
        />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!isAdmin) {
    return (
      <div className="p1">
        <h2>Access Denied</h2>
        <p>You don't have permission to access this page.</p>
      </div>
    );
  }

  return children;
};

export default AdminRoute;